import { Button, Typography } from "@saviynt/design-system";
import { FormattedMessage } from "react-intl";
import { useTheme } from "../../../contexts/ThemeContext";
import "./SsoLandingPage.css";

interface SsoLandingPageProps {
  onCreateSaml: () => void;
}

export default function SsoLandingPage({ onCreateSaml }: SsoLandingPageProps) {
  const { theme } = useTheme();

  const iconSrc =
    theme === "dark" ? "/sso-saml-icon-dark.svg" : "/sso-saml-icon-light.svg";

  return (
    <div className="SsoLanding">
      <div className="SsoLanding__header">
        <Typography
          kind="display2-light"
          color="--color-foreground-secondary-medium"
          className="SsoLanding__title"
        >
          <FormattedMessage
            id="tLi04L"
            defaultMessage="Start configuring your first SSO provider!"
            description="SSO landing page main heading"
          />
        </Typography>
        <Typography
          kind="body1"
          color="--color-foreground-secondary-bold"
          className="SsoLanding__description"
        >
          <FormattedMessage
            id="8CRRBX"
            defaultMessage="Single Sign-On (SSO) lets you log in once and access multiple apps or systems without signing in again. It makes login easier and more secure by using one trusted identity provider. Choose a protocol and set up seamless login for your users."
            description="SSO landing page description text"
          />
        </Typography>
      </div>

      <div className="SsoLanding__card">
        <div className="SsoLanding__cardContent">
          <img
            src={iconSrc}
            alt=""
            aria-hidden="true"
            className="SsoLanding__cardIcon"
          />
          <Typography kind="h3" color="--color-foreground-neutral-bold">
            <FormattedMessage
              id="LAXxN+"
              defaultMessage="SAML"
              description="SAML protocol card title"
            />
          </Typography>
          <Typography
            kind="body2"
            color="--color-foreground-neutral-subtle"
            className="SsoLanding__cardDescription"
          >
            <FormattedMessage
              id="6tuyTP"
              defaultMessage="Enterprise login protocol for single sign-on across multiple apps via an identity provider."
              description="SAML protocol card description"
            />
          </Typography>
          <Button kind="subtle" size="medium" onClick={onCreateSaml}>
            <FormattedMessage
              id="OwoHO1"
              defaultMessage="Select"
              description="Select protocol button label"
            />
          </Button>
        </div>
      </div>
    </div>
  );
}
